export type MyProfileResponseType = {
  id: string;
  uuid: string;
  email: string;
  pictureUrl: string | null;
  isEmailVerified: boolean;
  role: string | null;
  permissions: string[];
  status: string;
  isSuper: boolean;
  is2FAEnabled: boolean;
  hasActiveSubscription: boolean;
  activeSubscription: {
    startDate: string; // ISO timestamp
    endDate: string; // ISO timestamp
    hasExpired: boolean;
    availableSeats: number;
    usedSeats: number;
    subscriptionPlan: {
      id: string;
      title: string;
    };
  };
  isAutoSubscriptionEnabled: boolean;
  firstName: string;
  lastName: string;
  dateOfBirth: string; // ISO timestamp
  phoneNumber: string | null;
  country: string;
  userType: string;
  gender: string;
  isActive: boolean;
  orgType: string | null;
  orgName: string | null;
  orgSize: string | null;
  parentEmail: string | null;
  parentId: string | null;
  parentalControlStartTime: string; // ISO timestamp
  parentalControlEndTime: string; // ISO timestamp
  isOnboardingCompleted: boolean;
  isExpressRegistration: boolean;
  controlPin: string;

  //virtual
  age?: string;

  //not returned from backend but used in frontend
  password: string;

  totalSubUsers: number;

  mustCompleteQuizForProgress: boolean;
};

export type FullChildProfileResponseType = {
  profile: MyProfileResponseType;
  contentCompletedCount: number;
  contentInProgressCount: number;
  badgeCount: number;
  certificateCount: number;
  criticalThinkingQuizAttempts: {
    id: string;
    title: string;
    thumbnail: string;
    criticalThinkingQuizId: string;
  }[];
};

export enum UserTypeEnum {
  PARENT = 'parent',
  CHILD = 'child',
  ORGANIZATION = 'organization',
  ADMIN = 'admin',
  SUPER = 'super',
}
